<template>
  <footer class="py-5 text-grey">
    <div class="container">
      <section class="footer-top">
        <section class="">
          <h3 class="mb-3 text-white">Neem contact op!</h3>
          <call-button background="#3D95D1"></call-button>
        </section>

        <nav class="footer-nav">
            <ul class="list-unstyled footer__link-list">
              <li>
                <router-link to="/" class="footer__link-prm text-white">Home</router-link>
              </li>
              <li>
                <router-link to="/over" class="footer__link">Over ons</router-link>
              </li>
              <li>
                <router-link to="/partners" class="footer__link">Partners</router-link>
              </li>
            </ul>
            <ul class="list-unstyled footer__link-list">
              <li>
                <router-link to="/diensten" class="footer__link-prm text-white">Diensten</router-link>
              </li>
              <li>
                <router-link to="/diensten" class="footer__link">CV-Installatie</router-link>
              </li>
              <li>
                <router-link to="/diensten" class="footer__link">Onderhoud</router-link>
              </li>
              <li>
                <router-link to="/diensten" class="footer__link">Installatiewerk</router-link>
              </li>
              <li>
                <router-link to="/diensten" class="footer__link">Woningventalatie</router-link>
              </li>
            </ul>
            <ul class="list-unstyled footer__link-list">
              <li>
                <router-link to="/contact" class="footer__link-prm text-white">Contact</router-link>
              </li>
              <li>
                <router-link to="/contact" class="footer__link">
                  <i class='bx bxs-phone'></i>
                  <span class="ml">Bellen</span>
                </router-link>
              </li>
              <li>
                <router-link to="/contact" class="footer__link">
                  <i class='bx bxs-envelope'></i>
                  <span class="ml">Mailen</span>
                </router-link>
              </li>
            </ul>
        </nav>
      </section>

      <hr class="my-4">

      <section class="row align-items-center">
        <section class="col-12 col-md-3 d-flex align-items-center">

          <figure class="footer-logo__svg-figure d-flex align-items-center">
            <svg data-v-4e765883="" data-v-ca8c3fce="" class="footer-logo__svg logo__svg" id="Layer_2"
                 data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 488.41 171.94" fill="#fff">
              <g id="Layer_1-2" data-name="Layer 1" data-v-4e765883="">
                <g data-v-4e765883="">
                  <g data-v-4e765883="">
                    <path
                        d="m224.94,29.33v12.23c0,1.83,1.48,3.31,3.31,3.31h14.4c1.83,0,3.31,1.48,3.31,3.31v73.15c0,4.93-2.84,9.48-7.36,11.46-.04.02-.09.04-.13.06l-.07.03c-2.52,1.06-5.32,1.35-7.97.69-11.94-2.97-11.3-12.56-11.3-12.56v-10.46c0-1.83-1.48-3.31-3.31-3.31h-19.48c-1.83,0-3.31,1.48-3.31,3.31v14.95c0,2.47.62,4.89,1.82,7.04,3.57,6.37,13.54,17.68,39.5,18.2,1.27.03,20.27,1.4,33.34-12.16,3-3.12,5.06-6.35,6.47-9.13,1.01-2,1.51-4.21,1.51-6.45V48.18c0-1.83,1.48-3.31,3.31-3.31h6.43c1.83,0,3.31-1.48,3.31-3.31v-12.95c0-1.83-1.48-3.31-3.31-3.31h-56.45c-2.23,0-4.04,1.81-4.04,4.04Z"
                        data-v-4e765883=""></path>
                    <path
                        d="m397.66,85.67c-2.74-1.24-3.02-4.99-.49-6.61,6.03-3.86,12.56-10.86,12.94-23.19.72-23.2-24.65-30.45-31.17-30.45h-75.99c-2.07,0-3.76,1.68-3.76,3.76v9.16c0,2.07,1.68,3.76,3.76,3.76h9.89c2.07,0,3.76,1.68,3.76,3.76v80.21c0,2.07-1.68,3.76-3.76,3.76h-9.89c-2.07,0-3.76,1.68-3.76,3.76v11.34c0,2.07,1.68,3.76,3.76,3.76h74.39c.09,0,.18,0,.27,0,1.98.15,29.74,1.65,33.24-31.91,2.05-19.72-5.9-27.8-13.18-31.1Zm-15.82,26.02c-.68,15.71-18.09,17.91-20.11,18.11-.12.01-.24.02-.36.02h-17.1c-2.07,0-3.76-1.68-3.76-3.76v-28.74c0-2.07,1.68-3.76,3.76-3.76h17.27c2.9,0,21.02,1.45,20.3,18.12Zm0-51.47c-.68,15.71-18.09,17.91-20.11,18.11-.12.01-.24.02-.36.02h-17.1c-2.07,0-3.76-1.68-3.76-3.76v-28.74c0-2.07,1.68-3.76,3.76-3.76h17.27c2.9,0,21.02,1.45,20.3,18.12Z"
                        data-v-4e765883=""></path>
                    <path
                        d="m428.6,25.41h53.65c1.8,0,3.26,1.46,3.26,3.26v12.33c0,1.8-1.46,3.26-3.26,3.26h-10.15c-1.8,0-3.26,1.46-3.26,3.26v79.02c0,1.8,1.46,3.26,3.26,3.26h10.15c1.8,0,3.26,1.46,3.26,3.26v12.33c0,1.8-1.46,3.26-3.26,3.26h-53.65c-1.8,0-3.26-1.46-3.26-3.26v-12.33c0-1.8,1.46-3.26,3.26-3.26h10.15c1.8,0,3.26-1.46,3.26-3.26V45.35c0-1.8-1.46-3.26-3.26-3.26h-10.15c-1.8,0-3.26-1.46-3.26-3.26v-10.15c0-1.8,1.46-3.26,3.26-3.26Z"
                        data-v-4e765883=""></path>
                  </g>
                  <path id="Icon_metro-fire-2" data-name="Icon metro-fire-2"
                        d="m39.79,168.68c.54.31,1.17-.25.91-.82-10.17-22.46-4.22-35.6,4.26-47.99,5.46-7.98,9.41-16.89,11.66-26.29.13-.56.86-.68,1.16-.19,1.74,2.89,5.51,10.61,4.05,21.45-.09.65.73,1.01,1.14.5,11.26-13.98,13.87-34.4,12.5-43.9-.08-.56.55-.96,1.01-.62,28.47,20.9,40.73,64.11,25.13,96.99-.27.56.37,1.14.91.82,86.5-50.45,24.5-124.34,10.08-136.34-.28-.24-.7.06-.56.41,3.38,8.53,3.81,21.62-3.05,28.69-.35.36-.96.21-1.09-.28C95.47,15.39,67.34,2.26,61.7.04c-.45-.18-.91.2-.85.68,3.31,25.93-14.16,54.08-31.43,75.49-.37.46-1.1.21-1.14-.37-.57-9.13-1.37-15.93-5.78-24.64-.29-.57-1.14-.42-1.21.21-2.14,18.4-16.01,33.74-19.87,52.42-5.34,25.85,3.76,44.88,38.37,64.84Z"
                        data-v-4e765883=""></path>
                </g>
              </g>
            </svg>
          </figure>

          <ul class="social-links d-flex align-items-center">
            <li class="list-inline-item"><a href="https://github.com/M4TThys123/JBI-Installatieservice"><i
                class='bx bxl-github'></i></a></li>
            <li class="list-inline-item"><a href="https://www.linkedin.com/in/matthijs-blauw-9a9573235/"><i
                class='bx bxl-linkedin-square'></i></a></li>
          </ul>
        </section>

        <section class="col-12 col-md-9 end">
          <p class="footer-credits">
            &copy; JBI Installatietechniek {{ new Date().getFullYear() }} | Frontend Developer:
            <a href="https://www.matthijsblauw.nl/" class="text-white">Matthijs Blauw</a>
          </p>
        </section>

      </section>

    </div>
  </footer>
</template>


<script>
import CallButton from "@/lib/components/CallButton.vue";

export default {
  name: 'FooterComponent',
  components: {CallButton}
}
</script>

<style scoped>
footer {
  background: #14151A;
}

.footer-top{
  display: flex;
  flex-direction: column;

}

.footer-nav{
  display: flex;
  gap: 2em;
  margin-top: 2.5em;
  flex-wrap: wrap; /* Allow items to wrap onto the next line */
}

.footer__link-list {
  flex-direction: column;
  /*flex: 1 1 100%; !* Each list takes up full width on smaller devices *!*/

}

.footer__link {
  text-decoration: none;
  font-size: 16px;
  color: #9C9C9D;
}

.ml {
  margin-left: 2px;
}

hr{
  border-bottom: 3px solid rgba(255, 255, 255, .1);
}
.footer__link-prm {
  font-weight: bold;
  font-size: 20px;
  text-decoration: none;
  margin-bottom: 12px;
}

.footer-logo__svg {
  width: auto;
}

.footer-logo__svg-figure {
  width: 120px;
  margin: 0;
}

.social-links {
  padding-left: 0em;
}

.social-links i {
  font-size: 24px;
  color: white;
}

.footer-credits {
  margin-top: 2em;
  color: #9C9C9D;

}

.footer-credits a {
  text-decoration: none;
}

/* SM (for tablets - screens ≥ than 768px wide) */
@media (width >= 768px) {
  .footer-top{
    flex-direction: row;
    justify-content: space-between;
  }

  .footer-nav{
    margin-top: 0;
    flex-wrap: nowrap;
    gap: 4em;
  }

  .footer-credits{
    text-align: right;
    margin: 0;
  }
}
</style>